import ImageColumn from '@rover/components/src/cards/SearchResultCard/ImageColumn/ImageColumn';

export default ImageColumn;
